import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  constructor(private http: HttpClient) {}

  getStates(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/states`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching states:', error);
        },
      })
    );
  }

  getStakeholderTypes(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/stakeholdertypes`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching stakeholder types:', error);
        },
      })
    );
  }

  getOrganizationTypes(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/organizationtypes`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching organization types:', error);
        },
      })
    );
  }

  getCommentTopics(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/commenttopics`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching comment topics:', error);
        },
      })
    );
  }

  getCommentChoices(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/commentchoices`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching comment choices:', error);
        },
      })
    );
  }

  getCommuterCategories(): Observable<any> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };
    return this.http.get<any>(`${environment.ApiUrl}/Lookups/commutercategories`, options).pipe(
      tap({
        error: (error) => {
          console.error('Error fetching commuter categories:', error);
        },
      })
    );
  }
}
